var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.css.player,
    ( _obj = {}, _obj[_vm.css.fullScreen] = !_vm.halfScreen, _obj[_vm.css.halfScreen] = _vm.halfScreen, _obj ) ],attrs:{"id":_vm.playerElementId}})}
var staticRenderFns = []

export { render, staticRenderFns }